module.exports = __webpack_public_path__ + "img/blog-cover-default.9f881451.jpg";